// extracted by mini-css-extract-plugin
module.exports = {"animation_route":"style_animation_route__2V1k0","fadeRoute":"style_fadeRoute__2xOFw"};